var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0667 18C15.2148 18 13.3852 17.5964 11.5778 16.7893C9.77037 15.9822 8.12593 14.8376 6.64444 13.3556C5.16296 11.8735 4.01867 10.229 3.21156 8.42222C2.40444 6.61541 2.00059 4.78578 2 2.93333C2 2.66667 2.08889 2.44444 2.26667 2.26667C2.44444 2.08889 2.66667 2 2.93333 2H6.53333C6.74074 2 6.92593 2.07052 7.08889 2.21156C7.25185 2.35259 7.34815 2.51911 7.37778 2.71111L7.95556 5.82222C7.98519 6.05926 7.97778 6.25926 7.93333 6.42222C7.88889 6.58519 7.80741 6.72593 7.68889 6.84444L5.53333 9.02222C5.82963 9.57037 6.18133 10.0999 6.58844 10.6107C6.99556 11.1215 7.44385 11.6142 7.93333 12.0889C8.39259 12.5481 8.87407 12.9742 9.37778 13.3671C9.88148 13.76 10.4148 14.1191 10.9778 14.4444L13.0667 12.3556C13.2 12.2222 13.3742 12.1224 13.5893 12.056C13.8044 11.9896 14.0154 11.971 14.2222 12L17.2889 12.6222C17.4963 12.6815 17.6667 12.789 17.8 12.9449C17.9333 13.1007 18 13.2747 18 13.4667V17.0667C18 17.3333 17.9111 17.5556 17.7333 17.7333C17.5556 17.9111 17.3333 18 17.0667 18Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.229dbd7d08737c06172ea6f6bfa7a366.svg";
export { ForwardRef as ReactComponent };